import React from 'react';
import { CostosBaseServiciosVista } from '../../vista/costosBaseServiciosVista';
import { useEdicionFilas, type ICoordinacionEdicionProps } from '../../../../globales/componentes/tabla/useEdicionFilas';
import { configuracionServiciosInicial, generarIdTemporal } from '../../interfaces';
import type { ICostoBaseCapacidad, ICostoBaseRecorrido, IIncrementoAnualServicio } from '../../../../modelos/CotizadorServicios/entidades/IParametrosServicios';

/** Matrices de costo base e incremento anual: se agregan, editan y eliminan fila por fila. */
export const CostosBaseServiciosCV: React.FC<ICoordinacionEdicionProps> = (coordinacion) => {
    const costosCapacidad = useEdicionFilas<ICostoBaseCapacidad>({
        ...coordinacion,
        clave: 'costosCapacidad',
        datosIniciales: configuracionServiciosInicial.CostosBaseCapacidad,
        camposObligatorios: ['CapacidadKg', 'Costo'],
        crearFila: () => ({ Id: generarIdTemporal(), CapacidadKg: '' as unknown as number, Costo: '' as unknown as number }),
        permiteEliminar: true
    });

    const costosRecorrido = useEdicionFilas<ICostoBaseRecorrido>({
        ...coordinacion,
        clave: 'costosRecorrido',
        datosIniciales: configuracionServiciosInicial.CostosBaseRecorrido,
        camposObligatorios: ['RecorridoMm', 'Costo'],
        crearFila: () => ({ Id: generarIdTemporal(), RecorridoMm: '' as unknown as number, Costo: '' as unknown as number }),
        permiteEliminar: true
    });

    const incrementosAnuales = useEdicionFilas<IIncrementoAnualServicio>({
        ...coordinacion,
        clave: 'incrementosAnuales',
        datosIniciales: configuracionServiciosInicial.IncrementosAnuales,
        camposObligatorios: ['Anio', 'Porcentaje'],
        crearFila: () => ({ Id: generarIdTemporal(), Anio: '' as unknown as number, Porcentaje: '' as unknown as number }),
        permiteEliminar: true
    });

    return <CostosBaseServiciosVista costosCapacidad={costosCapacidad} costosRecorrido={costosRecorrido} incrementosAnuales={incrementosAnuales} />;
};
